/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import { computeImageSourceType } from 'Helpers/images';

export class Image extends React.PureComponent {
    renderSources = () => {
        const { sourceConfig, types } = this.props;

        return types.map((type, index) => {
            return <source key={ index } type={ computeImageSourceType(type) } srcSet={ sourceConfig[type] } />;
        });
    }

    handleImageError = () => {
        if (this.props.onError) {
            this.props.onError();
        }
    }
    render() {
        const { url, className, sourceConfig, types, ...rest } = this.props;

        return (
            <picture>
                { types.length > 0 && this.renderSources() }
                <img
                    src={ url }
                    className={ className }
                    loading="lazy"
                    onError={ this.handleImageError }
                    { ...rest }
                />
            </picture>

        );
    }
}

Image.propTypes = {
    url: PropTypes.string,
    sourceConfig: PropTypes.object,
    className: PropTypes.string,
    types: PropTypes.array,
    onError: PropTypes.func
};

Image.defaultProps = {
    className: '',
    sourceConfig: {},
    types: [],
    onError: null
};

export default Image;
